import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import {
  ConfiguracionTablaSincrona,
  DatosTabla,
} from 'src/app/compartido/tabla/utilidades/tabla.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';

/* Configuración de la ficha de Evedisa Mipres */
export const CONFIGURACION_FICHA_EVEDISA_MIPRES: ConfiguracionFicha = {
  header: { titulo: 'Moléculas Mipres', icono: Icono.MEDICAMENTO },
};

/* Configuración de la tabla de Evedisa Mipres */
export const CONFIGURACION_TABLA_EVEDISA_MIPRES: ConfiguracionTablaSincrona = {
  columnas: [
    { nombre: 'Molécula', slug: 'molecula' },
    { nombre: 'Descripción', slug: 'descripcion' },
  ],
  busqueda: true,
};

/* Moléculas que requieren Mipres */
export const MOLECULAS_MIPRES: DatosTabla = [
  {
    molecula: 'Pegcetacoplan 54Mg/Ml Solución Inyectable',
    descripcion: 'Pegcetacoplan 1080Mg/20Ml Sln Iny Vial',
  },
  {
    molecula: 'Ezetimiba 10 Mg Tableta',
    descripcion: 'Zemib 10 Mg Caja X 21',
  },
  {
    molecula: 'Ezetimiba 10 Mg Tableta',
    descripcion: 'Ezetimiba 10Mg Tab Cj X 150',
  },
  {
    molecula: 'Ezetimiba 10 Mg Tableta',
    descripcion: 'Zetia 10Mg Tab (Cd) Cj X 10',
  },
  {
    molecula: 'Glucosamina 1500 (37.98) Mg (G) Granulado',
    descripcion: 'Gluconitrin Simple Polv Liof 1500Mg X 60',
  },
  {
    molecula: 'Glucosamina 1500 (37.98) Mg (G) Granulado',
    descripcion: 'Glucosamina Sob 1500Mg X 60',
  },
  {
    molecula: 'Glucosamina 1500 (37.98) Mg (G) Granulado',
    descripcion: 'Glucosamina Sob 1500Mg X 15',
  },
  {
    molecula: 'Ketoprofeno 2.5 % Gel Topico',
    descripcion: 'Ketoprofeno Gel 2.5% X 60G Ins',
  },
  {
    molecula: 'Ketoprofeno 2.5 % Gel Topico',
    descripcion: 'Ketum Gel Tub X 30Gr',
  },
  {
    molecula: 'Ketoprofeno 2.5 % Gel Topico',
    descripcion: 'Profenid 2.5 Gel Tub X 30Gr',
  },
  {
    molecula: 'Minoxidil 5 (5) G/100 Ml (%) Espuma Topica',
    descripcion: 'Edapil M R001-500-615 Esp Top Aer X100G',
  },
  {
    molecula: 'Orlistat 120 Mg Capsula',
    descripcion: 'Orlistat 120Mg Cap (Cd) Ecar Cj X 60',
  },
  {
    molecula: 'Orlistat 120 Mg Capsula',
    descripcion: 'Orlistat 120Mg Cap Colm (Cd) Cj X 60',
  },
  {
    molecula: 'Orlistat 120 Mg Capsula',
    descripcion: 'Grazilan 120 Mg (Cd) Cap Cj X 40',
  },
  {
    molecula: 'Piracetam 800 Mg Tableta',
    descripcion: 'Neurobasal Tab Cj X 30',
  },
  {
    molecula: 'Piracetam 800 Mg Tableta',
    descripcion: 'Piracetan 800Mg Tab Mk Cj X 30',
  },
  {
    molecula:
      'Tratamiento De Dermatitis Seborreica (Mactral)   Emulsion (Shampoo)',
    descripcion: 'Mactral Shp Aulen Fco X 150Ml',
  },
  {
    molecula: 'Urea (Carbamida) 15 (15) % (G/100 G) Crema Topica',
    descripcion: 'Ureaderm 15% Crem Scan Tub X 60Gr',
  },
  {
    molecula: 'Valganciclovir 450 Mg Tableta',
    descripcion: 'Valkir Tab (Cd) Fco X 60',
  },
  {
    molecula: 'Valganciclovir 450 Mg Tableta',
    descripcion: 'Valgovir 450Mg Tab (Cd) Cj X 30',
  },
  {
    molecula: 'Valganciclovir 450 Mg Tableta',
    descripcion: 'Tixvan 450Mg Tab (Cd) Cj X 60',
  },
  {
    molecula: 'Riluzol 50 Mg Tableta',
    descripcion: 'Riluzol 50Mg Tab Actif (Cd) Cj X 56',
  },
  {
    molecula: 'Riluzol 50 Mg Tableta',
    descripcion: 'Riluzol 50Mg Tab Cj X56',
  },
  {
    molecula: 'Riluzol 50 Mg Tableta',
    descripcion: 'Extensik 50 Mg Tab Recu (Cd) Cj X 56',
  },
  {
    molecula: 'Antidermatitis Antiseborreico (Pilofast)   Emulsion (Shampoo)',
    descripcion: 'Pilofast Champu Fco X 280Ml',
  },
  {
    molecula: 'Felbamato 600 Mg Tableta',
    descripcion: 'Felbamato 600Mg Tab Fco X 100',
  },
  {
    molecula: 'Panitos Humedos   No Aplica',
    descripcion: 'Toalla Humeda Aloe Natural Familia X 100',
  },
  {
    molecula: 'Sirolimus 1 Mg Tableta',
    descripcion: 'Rapamune 1Mg Tab (Cd7) Cj X 100',
  },
  {
    molecula:
      'Clobetasol - Minoxidil - Acido Retinoico (Tretinoina) 100 - 5 - 25 Mg/100Ml - G/100Ml - Mg/100Ml  Solucion Topica',
    descripcion: 'Folister Complex Hair Lotion X 60Ml',
  },
  {
    molecula: 'Tetrabenazina 25 Mg Tableta',
    descripcion: 'Tetmodis 25Mg Tab Cj X 112',
  },
  {
    molecula: 'Suplemento Nutricional (Pulmocare )   Emulsion Oral',
    descripcion: 'Pulmocare Emul Abbot Lat X 8Oz',
  },
  {
    molecula:
      'Formula Nutricional Enteral Baja En Carbohidratos Para Pacientes Diabeticos (Glucerna)   Suspension Oral',
    descripcion: 'Glucerna Vainilla Rpb Abbot Lat X 8Oz',
  },
  {
    molecula:
      'Formula Nutricional Enteral Baja En Carbohidratos Para Pacientes Diabeticos (Glucerna)   Suspension Oral',
    descripcion: 'Glucerna Fresa Rpb Abbot Fco X237Ml',
  },
  {
    molecula:
      'Producto Natural Con Factores De Transferencia Inmunitaria (4 Life Research Transfer Factor Plus)   Capsula',
    descripcion: '4Life Transfer Factor Cap X 90',
  },
  {
    molecula: 'Protector Solar (Umbrella Spf 50)   Crema Topica',
    descripcion: 'Umbrella Crem 50+ Scan Tub X 60Gr',
  },
  {
    molecula: 'Formula Nutricional Para Lactantes (Infatrini)   Emulsion Oral',
    descripcion: 'Infatrini Liq Fco X 125Ml',
  },
  {
    molecula:
      'Suplemento Nutricional (Ensure Advance) 850Gr Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Ensure Advance Vainilla X 850G',
  },
  {
    molecula:
      'Suplemento Nutricional (Ensure Advance) 850Gr Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Ensure Advance Fresa Polv Lata X 850G',
  },
  {
    molecula:
      'Formula Nutricional Hipoalergenica Para Lactantes Alergicos A La Leche De Vaca (Neocate Infant)   Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Neocate Jun Prebiot Vain Polv Lata 400G',
  },
  {
    molecula:
      'Formula Nutricional Hipoalergenica Para Lactantes Alergicos A La Leche De Vaca (Neocate Infant)   Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Neocate Jun Prebiot Neutr Polv Lata 400G',
  },
  {
    molecula: 'Protector Solar (Umbrella Spf 50)   Gel Topico',
    descripcion: 'Umbrella Gel 50+ Scan Tub X 60Gr',
  },
  {
    molecula:
      'Protector Solar (Umbrella Plus Spray 50) Frasco X120Gr Emulsion Topica',
    descripcion: 'Umbrella Plus 50+ Scan Fco X 120Gr',
  },
  {
    molecula:
      'Alimento Para Pacientes Con Enfermedad Renal Cronica Estadio 3 Y 4 (Nepro Bp)   Emulsion Oral',
    descripcion: 'Nepro Bp Abbot Lat X 237Ml',
  },
  {
    molecula: 'Alimento Alto En Proteinas (Nepro Ap)   Emulsion Oral',
    descripcion: 'Nepro Ap Abbot Lat X 237Ml',
  },
  {
    molecula: 'Suplemento Nutricional (Fresubin 2Kcal)  Emulsion Oral',
    descripcion: 'Fresubin 2 Kcal Drink Vainil Liq X 200Ml',
  },
  {
    molecula: 'Suplemento Nutricional (Fresubin 2Kcal)  Emulsion Oral',
    descripcion: 'Fresubin 2 Kcal Frutos Liq X200Ml',
  },
  {
    molecula:
      'Formula Nutricional (Ensure Clinical) Frasco X 220Ml Emulsion Oral',
    descripcion: 'Ensure Clinical Abbot Fco X 220Ml',
  },
  {
    molecula:
      'Formula Nutricional Enteral Completa Pediatrica Liquida (Pediasure Clinical) X 220Ml Emulsion Oral',
    descripcion: 'Pediasure Clinical Abbot Fco X 220 Ml',
  },
  {
    molecula: 'Protector Solar (Sol-Or Ultra Luminate Fps 50)   Crema Topica',
    descripcion: 'Sol-Or Ultra Luminate Spf 50 Tubo X 100G',
  },
  {
    molecula: 'Formula Nutricional (Vital 1.5) Frasco X 220Ml Emulsion Oral',
    descripcion: 'Vital 1,5 Liqui Fco X220 Ml',
  },
  {
    molecula: 'Protector Solar (Bloksol Fps 50)   Crema Topica',
    descripcion: 'Bloksol Bloq Solar Spf 50 X 60G',
  },
  {
    molecula: 'Fitostimoline   Gel',
    descripcion: 'Fitostimoline Gel Tub X 32Gr',
  },
  {
    molecula: 'Cannabidiol 100 Mg/Ml Solucion Oral',
    descripcion: 'Neviot 100Mg/Ml Sln Oral Fco X 60Ml',
  },
  {
    molecula:
      'Liraglutida 6 (18) Mg/Ml (Mg/3 Ml) Solucion Inyectable (Saxenda)',
    descripcion: 'Saxenda 6Mg/Ml Sln Iny (Cd7) Cj X 1',
  },
  {
    molecula: 'Octodir Plus Shp Anticaspa Novad Fco X 220Ml',
    descripcion: 'Octodir Plus Shp Anticaspa Fco 220Ml',
  },
  {
    molecula: 'Cetaphil Crem Hidra Gald Pote X 453Ml',
    descripcion: 'Cetaphil Crem Hidra Gald Pote X 453Ml',
  },
  {
    molecula:
      'Suplemento Nutricional (Pediasure) Lata X 900Gr Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Pediasure Polv Vainilla Lat X 900G',
  },
  {
    molecula:
      'Suplemento Nutricional (Pediasure) Lata X 900Gr Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Pediasure Polv Fresa Abbot Lat X 900Gr',
  },
  {
    molecula: 'Diben Drink  Fco X 200 Ml',
    descripcion: 'Diben Drink Sabor A Vainilla X200Ml',
  },
  {
    molecula: 'Diben Drink  Fco X 200 Ml',
    descripcion: 'Diben Drink Sabor Capuchino X 200Ml',
  },
  {
    molecula:
      'Formula Nutricional De Proteinas (Prowhey Kalori Lpm) Frasco X 90Gr Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Prowhey Kalori Vain Caram Polv Fco 90G',
  },
  {
    molecula: 'Alimento Para Propositos Medicos Especiales X 220 Ml(Pediasure)',
    descripcion: 'Pediasure Vainilla Rpb Fco X 220Ml',
  },
  {
    molecula: 'Alimento Para Propositos Medicos Especiales X 220 Ml(Pediasure)',
    descripcion: 'Pediasure Fresa Rpb Fco X 220Ml',
  },
  {
    molecula: 'Suplemento Nutricional (Prosure) Frasco X 220Ml Emulsion Oral',
    descripcion: 'Prosure Liq Rpb Vain Bot X 220Ml',
  },
  {
    molecula:
      'Alimento Para Propositos Medicos Especiales X 200 Ml (Ensure Twocal)',
    descripcion: 'Ensure Twocal Liq Rpb 200Ml',
  },
  {
    molecula: 'Protector Solar (Umbrella Spf 100) Tubo X 5Ogr??Crema Topica',
    descripcion: 'Umbrella Intelligent Scan Tub X 50Gr',
  },
  {
    molecula:
      'Formula Nutricional De Proteinas (Prowhey Neumo) Lata X 435Gr Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Prowhey Neumo Vain Lata X 435G',
  },
  {
    molecula: 'Suplemento Nutricional (Glucerna 1.6 Hmb) X 220Ml Emulsion Oral',
    descripcion: 'Glucerna 1.6 Hmb Rpb 220Ml',
  },
  {
    molecula: 'Cannabidiol 200Mg Capsula Blanda',
    descripcion: 'Neviot 200 Mg Cbg Cj X 20',
  },
  {
    molecula: 'Alcohol Glicerinado X 1000Ml',
    descripcion: 'Alcohol Glicerinado Para Manos X1000Ml',
  },
  {
    molecula:
      'Alimento Liquido Para Propositos Medicos Especiales Polimerico X 220 Ml (Ensure Rpb)',
    descripcion: 'Ensure Base Vainilla Rpb Fco X 220Ml',
  },
  {
    molecula: 'Almipro Emoliente Frasco X 400Gr',
    descripcion: 'Almipro Emoliente Sanjor Fco X 400Gr',
  },
  {
    molecula:
      'Calcio (Carbonato De Calcio) - Vitamina D3 (Colecalciferol) 1500 (600) - 200 Mg (Mg) - U.I.  Tableta Masticable',
    descripcion: 'Calc+Vitad3 600Mg/200I.U Tab Mas Cj X300',
  },
  {
    molecula: 'Eucerin Loc Bdf Frasco X 400Ml',
    descripcion: 'Eucerin Loc Bdf Fco X 400Ml',
  },
  {
    molecula: 'Humectante (Lubriderm Extra Humectante) X 400Ml Crema Topica',
    descripcion: 'Lubriderm C Perf Extr Humec Fco 400Ml',
  },
  {
    molecula: 'Humectante (Lubriderm Extra Humectante) X 750Ml Crema Topica',
    descripcion: 'Lubriderm C/Perf Ext Hum Val Fco 750Ml',
  },
  {
    molecula:
      'Humectante (Lubriderm Reparacion Intensiva) X 400Ml Crema Topica',
    descripcion: 'Lubriderm Crem Rep Intens Fco 400Ml',
  },
  {
    molecula:
      'Humectante (Lubriderm Reparacion Intensiva) X 750Ml Crema Topica',
    descripcion: 'Lubriderm Rep Intensiva Fco 750Ml',
  },
  {
    molecula: 'Johnsons Shampoo Original X 200Ml',
    descripcion: 'J&J Shp Orig Fco X200Ml',
  },
  {
    molecula: 'Pañal Adulto Talla L No Aplica',
    descripcion: 'Tena Slip Clasico Large Pqte X 30',
  },
  {
    molecula: 'Pañal Adulto Talla L No Aplica',
    descripcion: 'Content Medical L Pqte X 30',
  },
  {
    molecula: 'Pañal Adulto Talla L No Aplica',
    descripcion: 'Content Med Advance  L X 60',
  },
  {
    molecula: 'Pañal Adulto Talla L No Aplica',
    descripcion: 'Pañal Tena Slip Ultra L X30 R.130005',
  },
  {
    molecula: 'Pañal Adulto Talla M  No Aplica',
    descripcion: 'Pañal Tena Slip Clasic Medi R.130008 X30',
  },
  {
    molecula: 'Pañal Adulto Talla M  No Aplica',
    descripcion: 'Content Medical M Pqte X 30',
  },
  {
    molecula: 'Pañal Adulto Talla M  No Aplica',
    descripcion: 'Content Med Advance  M X 60',
  },
  {
    molecula: 'Pañal Adulto Talla L No Aplica',
    descripcion: 'Content Ultrasec L Pqte X 30',
  },
  {
    molecula: 'Pañal Adulto Talla M  No Aplica',
    descripcion: 'Content Ultrasec M Pqte X30',
  },
  {
    molecula: 'Pañal Adulto Talla M  No Aplica',
    descripcion: 'Content Ultrasec Talla M Pqte X 21',
  },
  {
    molecula: 'Pañal Adulto Talla M  No Aplica',
    descripcion: 'Content Ultrasec Talla M X9',
  },
  {
    molecula: 'Pañal Adulto Talla S No Aplica',
    descripcion: 'Pañal Tena Slip Ultr Talla S R.47751 X30',
  },
  {
    molecula: 'Pañal Adulto Talla S No Aplica',
    descripcion: 'Content Med Advance  S X60',
  },
  {
    molecula: 'Pañal Adulto Talla S No Aplica',
    descripcion: 'Content Ultrasec S Adul Pqte X 30',
  },
  {
    molecula: 'Pañal Adulto Talla Xl  No Aplica',
    descripcion: 'Content Ultrasec Xl Adul Pqte X 30',
  },
  {
    molecula: 'Pañal Huggies Little Swimmers Talla M',
    descripcion: 'Huggies Pañal Little Swimmers T M X11',
  },
  {
    molecula: 'Pañal Plenitud Classic Tall G',
    descripcion: 'Plenitud Classic Tall G Colp Pqte X 20',
  },
  {
    molecula: 'Pañal Tena Pants Ultra Talla L',
    descripcion: 'Pañal Tena Pants Ultra Largue Pqte X 30',
  },
  {
    molecula: 'Pañal Tena Pants Ultra Talla M',
    descripcion: 'Pañal Tena Pants Ultra Medium Pqte X 30',
  },
  {
    molecula: 'Pañal Adulto Talla Xl  No Aplica',
    descripcion: 'Pañal Tena Slip Ultra Xl R.47752 X30',
  },
  {
    molecula: 'Pañal Ninos (Xxg) Etapa 6  No Aplica',
    descripcion: 'Winny Pañal Ult Gold Etapa 6 Pqte X30',
  },
  {
    molecula: 'Pañal Winny Ultrasec N3',
    descripcion: 'Winny Pañal Ultr Sec N° 3 X30 Gts 10 Toa',
  },
  {
    molecula: 'Pañal Winny Ultrasec N4',
    descripcion: 'Winny Pañal Ultr Sec N° 4 Mk Bol X 30',
  },
  {
    molecula: 'Pañal Ninos (Xg) Etapa 5  No Aplica',
    descripcion: 'Winny Pañal Ultr Sec N° 5 Mk Bol X 30',
  },
  {
    molecula: 'Protector Solar (Umbrella Urban)   Emulsion Topica',
    descripcion: 'Umbrella Urban Emul Tub X 50 G',
  },
  {
    molecula: 'Tena Discreet Super Toalla Higienica',
    descripcion: 'Tena Discreet Super Toa Hig Pqte X 10',
  },
  {
    molecula: 'Tena For Men Protect Noche Familiar',
    descripcion: 'Tena For Men Protect Noche Fami Pqt X 10',
  },
  {
    molecula: 'Almipro Syndet Frasco X 400Ml',
    descripcion: 'Almipro Syndet Sanjor Fco X 400Ml',
  },
  {
    molecula: 'Pañal Adulto Talla M  No Aplica',
    descripcion: 'Pañal Tena Slip Ultra M X30 R.130002',
  },
  {
    molecula:
      'Provitamina B5+Vitamina E+Acido Hialuronico Emulsion Topica Frasco 240Gr (Emolin Neo)',
    descripcion: 'Emolin Neo Emul Fco X 240Gr',
  },
  {
    molecula:
      'Bloqueador Solar Spf 50 Emulsion (Isdin Fusion Water Spf 50+) Frasco X 50Ml',
    descripcion: 'Isdin Fusion Water Spf 50+ Fco 50Ml',
  },
  {
    molecula: 'Contreac 4  -Locion Tratamiento Corporal Fco 110 Ml X 1',
    descripcion: 'Contreac 4  -Locion Tratamiento Corporal Fco 110 Ml X 1',
  },
  {
    molecula: 'Neotone Eyes Contorno De Ojos Tubo X 15Ml',
    descripcion: 'Neotone Eyes Contorno De Ojos Tubo X 15Ml',
  },
  {
    molecula: 'Selexipag 1000 Mcg Tableta Recubierta',
    descripcion: 'Uptravi 1000Mcg Tab Cj X 60',
  },
  {
    molecula: 'Selexipag 800 Mcg Tableta Recubierta',
    descripcion: 'Uptravi 800Mcg  Tab Cj X 60',
  },
  {
    molecula: 'Ciclosilicato De Sodio - Zirconio 5G Pol Para Susp',
    descripcion: 'Lokelma Pwd 5G Scht Cj X 30',
  },
  {
    molecula: 'Magnesio Oxido 400Mg Capula',
    descripcion: 'Magnesio Oxido 400Mg Cap X100',
  },
  {
    molecula: 'Fitostimoline   Crema Topica',
    descripcion: 'Fitostimoline Crem Tub X 60Gr',
  },
  {
    molecula: 'Pañal Adulto Talla Xl  No Aplica',
    descripcion: 'Content Med Advance Xl X 60',
  },
  {
    molecula: 'Selexipag 200 Mcg Tableta Recubierta',
    descripcion: 'Uptravi 200Mcg. 14 Bls X 10 Tab X140',
  },
  {
    molecula:
      'Formula Nutricional De Proteinas (Prowhey Oncare) Sobre X 56Gr Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Prowhey Oncare Polv Vainilla Sob X 56G',
  },
  {
    molecula: 'Vichy Dercos Shp Antic Fco X200Ml',
    descripcion: 'Vichy Dercos Shp Antic Fco X200Ml',
  },
  {
    molecula: 'Kli Heel Tab Fsco X 50',
    descripcion: 'Kli Heel Tab Fsco X 50',
  },
  {
    molecula:
      'Alimento Para Propositos Medicos Especiales (Argiment At) Sobre 42.75Gr',
    descripcion: 'Argiment At Polv Sob X 42,75G',
  },
  {
    molecula:
      'Formula Nutricional De Proteinas (Prowhey Dm) Sobre X 56Gr Polvo Para Reconstituir A Emulsion Oral',
    descripcion: 'Prowhey Dm 56Gr Boyd Sob X 1',
  },
];
